<template>
  <div style="position: relative;">
    <el-row>
      <el-col :span="24">
        <el-table ref="specialistCertificate" :data="specialistCertificateList.SpecialistCertificate.impl.dataList" :size="defaultFormItemSize" @sort-change="specialistCertificateList.SpecialistCertificate.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="specialistCertificateList.SpecialistCertificate.impl.getTableIndex" />

          <el-table-column label="证书名称" prop="certificateName">
          </el-table-column>
          <el-table-column label="证书编号" prop="certificateNo">
          </el-table-column>
          <el-table-column label="签发年份" prop="signYear">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.signYear, 'year')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="专家名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="类型" prop="specialistTypeDictMap.name">
          </el-table-column>
          <el-table-column label="证书图片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.certificatePhoto, {id: scope.row.id, fieldName: 'certificatePhoto', asImage: true})"
                        :preview-src-list="getPictureList(scope.row.certificatePhoto, {id: scope.row.id, fieldName: 'certificatePhoto', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <a v-for="item in parseUploadData(scope.row.certificatePhoto, {id: scope.row.id, fieldName: 'certificatePhoto', asImage: true})" :key="item.url"
                 href="javascript:void(0);" @click="downloadFile(item.url, item.filename)">
                下载证书
              </a>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialistCertificateList.SpecialistCertificate.impl.totalCount"
            :current-page="specialistCertificateList.SpecialistCertificate.impl.currentPage"
            :page-size="specialistCertificateList.SpecialistCertificate.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialistCertificateList.SpecialistCertificate.impl.onCurrentPageChange"
            @size-change="specialistCertificateList.SpecialistCertificate.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>

  </div>
</template>

<script>
/* eslint-disable-next-line */
import { TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import { SpecialistCertificateController, DictionaryController } from '@/api';
export default {
  name: 'SpecialistCertificate',
  props: {
    specialistId: null
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  cachedPageChildMixin,
  data () {
    return {
      specialistCertificateList: {
        SpecialistCertificate: {
          impl: new TableWidget(this.loadSpecialistCertificateWidgetData, this.loadSpecialistCertificateVerify, true, false)
        },
        isInit: false
      }
    }
  },
  methods: {
    /**
     * 专家对接历史数据获取函数，返回Promise
     */
    loadSpecialistCertificateWidgetData (params) {
      // alert(this.specialistId)
      if (params == null) params = {};
      params = {
        ...params,
        specialistCertificateDtoFilter: {
          specialistId: this.specialistId
        },
        orderParam: [{
          fieldName: 'createTime',
          asc: false
        }]
      }
      return new Promise((resolve, reject) => {
        SpecialistCertificateController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.specialistCertificateList.SpecialistCertificate.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.specialistCertificateList.SpecialistCertificate.impl.currentRow.id, 'id');
              this.$refs.SpecialistCertificate.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家对接历史数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSpecialistCertificateVerify () {
      return true;
    },
    /**
     * 更新服务历史
     */
    refreshSpecialistCertificateList (reloadData = false) {
      if (reloadData) {
        this.specialistCertificateList.SpecialistCertificate.impl.refreshTable(true, 1);
      } else {
        this.specialistCertificateList.SpecialistCertificate.impl.refreshTable();
      }
      if (!this.specialistCertificateList.isInit) {
        // 初始化下拉数据
      }
      this.specialistCertificateList.isInit = true;
    },
    formInit () {
      this.refreshSpecialistCertificateList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }

}
</script>

<style scoped>

</style>
